import { useEffect } from 'react';

/**
 * Modal/Drawer/Dialog'un paylastigi davranis: Escape ile kapanma ve acikken
 * arka planin kaydirilmamasi. Ayri dosyada — bkz. form-field-context.ts'teki
 * ayni gerekce (HMR bilesen siniri).
 */
export const useOverlay = (open: boolean, onClose: () => void): void => {
  useEffect(() => {
    if (!open) return;

    const onKeyDown = (event: KeyboardEvent): void => {
      if (event.key === 'Escape') {
        event.stopPropagation();
        onClose();
      }
    };

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open, onClose]);
};
